<template>
  <div data-qa="doctor_cards">
    <div
      v-for="doctor in doctors"
      :key="doctor.translit"
      data-qa="doctor_cards_item"
      :data-qa-translit="doctor.translit"
      class="d-flex flex-column align-center gr-4 py-4 elevation-1 rounded"
    >
      <div class="border-b-sm w-100 px-4">
        <v-img
          data-qa="doctor_cards_item_avatar"
          class="mx-auto"
          :src="doctor.avatar"
          lazy-src="/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg"
          alt="/"
          width="150"
          height="150"
          contain
        />
      </div>
      <div class="d-flex flex-column text-center gr-1 px-4">
        <a
          data-qa="doctor_cards_item_url"
          :href="doctor.url"
          class="text-center text-subtitle-1 primary--text text-decoration-none d-block"
        >
          {{ doctor.fio }}
        </a>
        <div
          data-qa="doctor_cards_item_town_name"
          class="text-body-2 text-secondary--text"
        >
          {{ doctor.townName }}
        </div>
        <div
          data-qa="doctor_cards_item_specialities"
          class="text-body-2 text-secondary--text"
        >
          <template v-for="(spec, index) in doctor.specialities">
            {{ index === 0 ? spec : ` • ${spec.toLowerCase()}` }}
          </template>
        </div>
        <div class="text-center text-body-2 text-secondary--text">
          {{ t('Заблокирован до', options) }}
          <span data-qa="doctor_cards_item_fraud_mark_expire_date">{{ doctor.fraudMarkExpireDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import type { Doctor } from 'src/components/pages/info/shame-mark/ShameMarkContent/types'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  doctors: Doctor[]
}>()
</script>
